import { defineMessages } from 'react-intl';

export default defineMessages({
  yourBalanceInAave: 'Your balance in SSAP',
  yourWalletBalance: 'Your wallet balance',
  totalDeposits: 'Total deposits',

  youBorrowed: 'You borrowed',
  totalCollateral: 'Total collateral',
  loanToValue: 'Loan to value',
});
